<!-- NAV BAR PERMANENT -->
@if (!isShellHidden()) {
  <app-nav-bar></app-nav-bar>
}

<div class="app-wrapper">
  <main class="main-content">
    <!-- TOUTES LES ROUTES SE LANCENT ICI AU MILIEU DU NAV ET FOOTER -->
    <div [@routeAnimations]="prepareRoute(outlet)" class="route-container">
      <router-outlet #outlet="outlet"></router-outlet>
    </div>
  </main>

  <!-- FOOTER PERMANENT -->
  @if (!isShellHidden()) {
    <app-footer></app-footer>
  }
</div>

<app-form-modal></app-form-modal>

<!-- Chat Bot -->
<!-- <app-chat-bot></app-chat-bot> -->